// Detects phone numbers and email addresses in free-text fields like property descriptions.
// Owners must keep contact details in their profile only.

// Email: standard pattern
const EMAIL_REGEX = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;

// Phone: catches international (+506 8888 8888), local (8888-8888, 8888 8888, 88888888),
// and digit sequences of 7+ separated by spaces/dots/dashes/parens.
const PHONE_REGEX = /(?:\+?\d[\s().-]?){7,}\d/;

export const CONTACT_INFO_ERROR =
  "No contact information allowed in this field. Please add this information to your profile";

export const containsContactInfo = (text: string): boolean => {
  if (!text) return false;
  return EMAIL_REGEX.test(text) || PHONE_REGEX.test(text);
};
